var CheckboxInputGroup = require('app/common/views/input-widgets/checkbox-input-group');

module.exports = {
    CheckboxInputGroup: CheckboxInputGroup,
};
